import api from "./axios";

export const organizationApi = {
  list: () => api.get("/organizations").then((r) => r.data),
  get: (id: string) => api.get(`/organizations/${id}`).then((r) => r.data),
  create: (data: {
    name: string;
    displayName?: string;
    description?: string;
  }) => api.post("/organizations", data).then((r) => r.data),
  update: (
    id: string,
    data: { name?: string; displayName?: string; description?: string },
  ) => api.patch(`/organizations/${id}`, data).then((r) => r.data),
  remove: (id: string) => api.delete(`/organizations/${id}`),
  getMembers: (id: string) =>
    api.get(`/organizations/${id}/members`).then((r) => r.data),
  addMember: (id: string, data: { email: string; role: string }) =>
    api.post(`/organizations/${id}/members`, data).then((r) => r.data),
  updateMemberRole: (id: string, userId: string, role: string) =>
    api
      .patch(`/organizations/${id}/members/${userId}`, { role })
      .then((r) => r.data),
  removeMember: (id: string, userId: string) =>
    api.delete(`/organizations/${id}/members/${userId}`),
};
